// Kept identical in the frontend and Functions packages; contract tests enforce parity.
export const NEWS_LIMITS = {
  post: 1500,
  comment: 1000,
  excerpt: 250,
  url: 2048,
  imageBytes: 5 * 1024 * 1024,
  page: 20,
  cooldownMs: 48 * 60 * 60 * 1000,
  commentCooldownMs: 3 * 60 * 60 * 1000,
} as const
export const normalizeNewsText = (value: string) => value.replace(/\r\n?/g, '\n').normalize('NFC').trim()
export const newsTextLength = (value: string) => Array.from(normalizeNewsText(value)).length
export const validNewsBody = (value: unknown, limit: number): value is string =>
  typeof value === 'string' && newsTextLength(value) > 0 && newsTextLength(value) <= limit
export const newsExcerpt = (body: string) => {
  const points = Array.from(normalizeNewsText(body).replace(/\s+/g, ' '))
  return points.slice(0, NEWS_LIMITS.excerpt).join('') + (points.length > NEWS_LIMITS.excerpt ? '…' : '')
}
export const validNewsUrl = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') return true
  if (
    typeof value !== 'string' ||
    value.length > NEWS_LIMITS.url ||
    Array.from(value).some((char) => char.charCodeAt(0) <= 32 || char.charCodeAt(0) === 127)
  )
    return false
  try {
    const url = new URL(value)
    return /^https?:\/\//i.test(value) && ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password
  } catch {
    return false
  }
}
export const validNewsImageMetadata = (name: string, type: string, size: number) =>
  size > 0 && size <= NEWS_LIMITS.imageBytes && ((/\.jpe?g$/i.test(name) && type === 'image/jpeg') || (/\.png$/i.test(name) && type === 'image/png'))
export const isNewsReader = (user: { role?: unknown; subscriptionStatus?: unknown } | null | undefined) =>
  user?.role === 'member' && (user.subscriptionStatus === 'active' || user.subscriptionStatus === 'unpaid')
export const hasNewsProfile = (user: Record<string, unknown>): boolean =>
  ['firstName', 'lastName', 'jobTitle', 'companyName', 'contactEmail', 'bio'].every(
    (key) => typeof user[key] === 'string' && (user[key] as string).trim().length > 0
  ) && ['workingIn', 'interestedIn'].every((key) => Array.isArray(user[key]) && (user[key] as unknown[]).length > 0)
